import { z } from "zod";

import type { IFeedbackRepository } from "@/core/repositories/interfaces/IFeedbackRepository";
import type { IFeedbackService } from "@/core/services/interfaces/IFeedbackService";
import type {
  ListFeedbacksInput,
  ListFeedbacksResult,
  MarkFeedbackSeenResult,
} from "@/core/services/types/feedback.types";

const listSchema = z.object({
  pageSize: z.number().int().positive().max(100).optional(),
  pageToken: z.string().nullable().optional(),
});

const markSeenSchema = z.object({
  id: z.string().min(1),
});

export class FeedbackService implements IFeedbackService {
  constructor(private readonly repository: IFeedbackRepository) {}

  async list(input: ListFeedbacksInput = {}): Promise<ListFeedbacksResult> {
    const parsed = listSchema.safeParse(input);
    if (!parsed.success) {
      console.error(
        "[FeedbackService.list] validation",
        parsed.error.flatten(),
      );
      return { feedbacks: [], nextPageToken: null };
    }

    return this.repository.list({
      pageSize: parsed.data.pageSize,
      pageToken: parsed.data.pageToken ?? null,
    });
  }

  async markSeen(id: string): Promise<MarkFeedbackSeenResult> {
    const parsed = markSeenSchema.safeParse({ id });
    if (!parsed.success) {
      console.error(
        "[FeedbackService.markSeen] validation",
        parsed.error.flatten(),
      );
      return { success: false, error: "invalid id" };
    }

    return this.repository.markSeen(parsed.data.id);
  }
}
